import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const cancelOrder = id =>
  axios({
    method: 'get',
    url: `${publicAPI}/order/cancel/${id}`,
  });
